// extracted by mini-css-extract-plugin
export default {"container":"inputFile_container__GRyJ5","wrapperButton":"inputFile_wrapperButton__IkIkB"};